import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryUserTreeList } from '@/api/api';
import pick from 'lodash.pick';
import moment from 'moment';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import IwsUpload from '@comp/upload/IwsUpload';
import { getAction, httpAction } from '@api/manage';
export default {
  name: 'MedicamentConfigureModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      siteName: '',
      userTree: [],
      //人员信息
      title: '药剂配置表单',
      tableName: 'om_medicament_configure',
      form_fields: ['siteId', 'userId', 'drugName', 'drugUsage', 'useUnit', 'drugUse', 'parameters', 'concentration', 'concentrationUnit', 'dosage', 'dosageUnit', 'remark', 'tenantId'],
      form_fields_time: ['configureDate'],
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请输入站点ID!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入配置人员!'
          }]
        },
        configureDate: {
          rules: [{
            required: true,
            message: '请输入配置时间!'
          }]
        } // drugName: { rules: [{ required: false, message: '请输入药品名称!' }] },
        // drugUsage: { rules: [{ required: false, message: '请输入药品使用量!' }] },

      }
    };
  },
  props: ['pagePath'],
  watch: {
    // currentSiteId(value) {
    //   this.siteId = value
    // },
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {
    this.loadTreeList();
  },
  methods: {
    handleOk: function handleOk() {
      var _this = this;

      var that = this; // 触发表单验证
      // debugger

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化
          // that.form_fields_time.forEach(function (item, index) {
          //   formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null
          // })

          formData.configureDate = formData.configureDate ? formData.configureDate.format('YYYY-MM-DD HH:mm:ss') : null; //将文件信息提交到后端保存数据库（此时的文件上传已经完成）

          formData = _this.$refs.iwupload.getUploadListToFromData(formData); //console.log(formData)

          var httpurl = '',
              method = '';

          if (!_this.model.id) {
            httpurl = _this.url.add ? _this.url.add : _this.pagePath;
            method = 'post';
          } else {
            httpurl = _this.url.edit ? _this.url.edit : _this.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              //文件上传
              _this.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    moment: moment,
    add: function add(siteId) {
      this.edit({
        siteId: siteId
      });
    },
    edit: function edit(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record); //调用编辑时，设置人员信息为当前用户

      this.model.userId = this.$store.getters.userInfo.id; //调用编辑时，给定一个当前的时间

      if (undefined == this.model.configureDate) {
        this.model.configureDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }

      this.getTableItem();
      this.visible = true;
      this.$nextTick(function () {
        var that = _this2; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    getTableItem: function getTableItem() {
      var _this3 = this;

      var params = {
        pageNo: 1,
        pageSize: 10000,
        partId: this.model.id
      };
      getAction('/om/medicament/configure', params).then(function (res) {
        _this3.dataItem = res.result.records;
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this4 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this4.loading = false;
        }
      });
    }
  }
};